import React, { memo, useMemo } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { formatTime } from './audioUtils';

const CropInfo = memo(({ cropStart, cropEnd, colors }) => {
    const formattedCropStart = useMemo(() => formatTime(cropStart), [cropStart]);
    const formattedCropEnd = useMemo(() => formatTime(cropEnd), [cropEnd]);
    const formattedCropDuration = useMemo(() => formatTime(cropEnd - cropStart), [cropStart, cropEnd]);

    return (
        <Box 
            sx={{ 
                bgcolor: colors.bgTertiary,
                borderRadius: 1,
                p: 1.5,
                border: `1px solid ${colors.borderSecondary}`
            }}
        >
            <Stack direction="row" spacing={3} alignItems="center">
                <Box>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            color: colors.textSecondary,
                            display: 'block',
                            mb: 0.25,
                            fontSize: '0.7rem'
                        }}
                    >
                        SELECTION START
                    </Typography>
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            fontWeight: 600,
                            color: '#fbbf24',
                            fontFamily: 'monospace'
                        }}
                    >
                        {formattedCropStart}
                    </Typography>
                </Box>
                
                <Box 
                    sx={{ 
                        width: 40, 
                        height: 1, 
                        bgcolor: colors.divider
                    }} 
                />
                
                <Box>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            color: colors.textSecondary,
                            display: 'block',
                            mb: 0.25,
                            fontSize: '0.7rem'
                        }}
                    >
                        SELECTION END
                    </Typography>
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            fontWeight: 600,
                            color: '#fbbf24',
                            fontFamily: 'monospace'
                        }}
                    >
                        {formattedCropEnd}
                    </Typography>
                </Box>
                
                <Box sx={{ flex: 1 }} />
                
                <Box>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            color: colors.textSecondary,
                            display: 'block',
                            mb: 0.25,
                            fontSize: '0.7rem'
                        }}
                    >
                        DURATION
                    </Typography>
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            fontWeight: 600,
                            color: colors.textPrimary,
                            fontFamily: 'monospace'
                        }}
                    >
                        {formattedCropDuration}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
});

CropInfo.displayName = 'CropInfo';

export default CropInfo;

